// New-work editor view — useful for verifying the portfolio work editor
// (draft saving, unsaved-changes guard, buttons) without an authenticated
// user: /styleguide/c/EditPortfolioWorkPage/NewWork/raw
import EditPortfolioWorkPage from './EditPortfolioWorkPage';

export const NewWork = {
  component: EditPortfolioWorkPage,
  props: {
    params: { type: 'new' },
  },
  group: 'pages',
};
